import styled from 'styled-components';

export const StyledBadge = styled.div`
  display: flex;
  align-items: center;
  margin-right: 12px;
  padding: 4px 5px;
  height: 24px;
  width: max-content;
  background: transparent;
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};

  font-size: ${({ theme }) => theme.FONT_SIZES.MEDIUM};
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};

  border: 2px solid ${({ theme }) => theme.COLORS.BASE_INVERTED};
  border-radius: 6px;
`;

export const StyledMake = styled.div`
  display: block;
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  white-space: nowrap;
  margin-right: 6px;
  font-size: ${({ theme }) => theme.FONT_SIZES.LARGE};
`;

export const StyledTitle = styled.div`
  display: inline-block;
  font-size: ${({ theme }) => theme.FONT_SIZES.LARGE};
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  margin-right: 6px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-shrink: 1;
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: ${({ theme }) => theme.FONT_SIZES.LARGE};
  line-height: 24px;
  @media only screen and (max-width: ${({ theme }) =>
      theme.BP.CUSTOM_DESKTOP_SMALL}) {
    width: 270px;
  }
`;
